(function() {
  window.Home = window.Home || {};
  Home.Behaviors = Home.Behaviors || {};

  function fireElement (type) {
    Polymer.Base.async(function(){
      var event = new Event(type + '-el-visually-ready');
      document.dispatchEvent(event);
    });
  }

  Home.Behaviors.PolymerUtil = {

    fireCardFeedElVisuallyReady: function (localName) {
      fireElement('card-feed', localName);
    },

    fireToolElVisuallyReady: function (localName) {
      fireElement('tool', localName);
    }
  };
}());